import {
    GET_CONFIG_FORM33,
 
} from '../types';


export default function consultarCasosReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM33:
            return { ...state, cfg_form33:action.payload }
      
     
        default:
            return state
    }
}